/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

export function isWaitlistMode(): boolean {
  return process.env["NEXT_PUBLIC_WAITLIST_MODE"] === "true";
}

export function openWaitlist(): void {
  window.dispatchEvent(new CustomEvent("open-waitlist"));
}
